import { render, staticRenderFns } from "./TemplateEventsFilters.vue?vue&type=template&id=2c7b1d7a&"
import script from "./TemplateEventsFilters.vue?vue&type=script&lang=js&"
export * from "./TemplateEventsFilters.vue?vue&type=script&lang=js&"
import style0 from "./TemplateEventsFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports